/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

import { useRouter } from 'next/router';

import { AppNavigation } from '../../AppNavigation';
import AppNotifications from '../../AppNotifications';
import { Footer } from '../../Footer';
import { PageHeaderBackground } from '../../PageHeaderBackground';
import SessionProvider from '../../SessionProvider';
import PageScroll from '../../Wrappers/PageScroll';
import PageTransition from '../../Wrappers/PageTransition';

type Props = {
  children: React.ReactNode;
  requireAuth?: boolean;
};

export function AppLayout({ children, requireAuth }: Props) {
  const { asPath } = useRouter();

  return (
    <>
      <AppNotifications />
      <PageScroll>
        <SessionProvider requireAuth={requireAuth}>
          <AppNavigation />
          <PageTransition type='fadeIn' id={asPath}>
            {children}
          </PageTransition>
          {requireAuth && <PageHeaderBackground />}
        </SessionProvider>
        <Footer />
      </PageScroll>
    </>
  );
}
